import { render, staticRenderFns } from "./VxCard.vue?vue&type=template&id=da1b9cfc&scoped=true"
import script from "./VxCard.vue?vue&type=script&lang=js"
export * from "./VxCard.vue?vue&type=script&lang=js"
import style0 from "./VxCard.vue?vue&type=style&index=0&id=da1b9cfc&prod&scoped=true&lang=css"
import style1 from "./VxCard.vue?vue&type=style&index=1&id=da1b9cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1b9cfc",
  null
  
)

export default component.exports